<!-- ======= Contact Section ======= -->
<section id="contact" class="contact">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Contacto</h2>
    </div>

    <div class="row mt-1">
      <div class="col-lg-12">
        <div class="info">
          <div class="contact">
            <div class="address">
              <i class="bi bi-geo-alt"></i>
              <h4>Ubicación:</h4>
              <p>Fuengirola, Málaga.</p>
            </div>

            <div class="email">
              <i class="bi bi-envelope"></i>
              <h4>Email:</h4>
              <a href="mailto:diegopaginidev@gmail.com" target="_blank"
                ><p>diegopaginidev@gmail.com</p></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Contact Section -->
